import { Component, OnInit, OnDestroy } from '@angular/core'
import { DataService } from '../services/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LOGIN } from '../utils/utils';

@Component({
    selector: 'logout',
    template:`<ng-content></ng-content>`
})
export class LogoutComponent implements OnInit, OnDestroy {

    constructor(
    	private dataservice: DataService,
    	private route: ActivatedRoute,
        private router: Router) { }

    ngOnInit() {
    	this.dataservice.logout(null, null);
    	//this.router.navigateByUrl(LOGIN);
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/logout/logout.component.ts